import script from "./DateWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./DateWidget.vue?vue&type=script&setup=true&lang=ts"

import "./DateWidget.vue?vue&type=style&index=0&id=643663e3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-643663e3"]])

export default __exports__